import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { tr } from "date-fns/locale";

const LocalDatePicker = ({ label, setValue, value }) => {
    return (
        <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700 mb-2">
                {label}
            </label>
            <DatePicker
                selected={value ? new Date(value) : null}
                onChange={(date) => setValue(date)}
                locale={tr}
                dateFormat="dd/MM/yyyy"
                placeholderText="GG/AA/YYYY"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="w-full p-2 bg-custom-gray rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
        </div>
    );
};

export default LocalDatePicker;
